import React from 'react';
import cls from 'classnames';
import {
  Row,
  Col,
} from 'antd';
import styles from './profileLytBase.module.scss';
import { useHistory } from 'react-router-dom';
import { CogIcon } from '../CogIcon';
import { getTranslations } from '../../../features/translations/translationsUtils';

interface ProfileLayoutProps {
  children: React.ReactNode;
  classname?: string,
  panelHeight?: string,
  topPanelColor?: string,
  includeGoBack?: boolean,
}

export const ProfileBase: React.FunctionComponent<ProfileLayoutProps> = ({ children, panelHeight, topPanelColor = 'e8ebf3', includeGoBack }) => {
  const history = useHistory();
  return (
    <React.Fragment>
      <div className={cls(styles.bkgndPanel, panelHeight)} style={{ backgroundColor: topPanelColor }}></div>
      <div className={styles.content}>
        {includeGoBack && <div onClick={() => history.goBack()} className={styles.goBackContainer}><CogIcon color="var(--tertiary-text-button-color)" icon="Arrow-left" /> {getTranslations('GENERAL_BACK')}</div>}
        <Row>
          <Col span={24}>
            {children ? children : null}
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}
